let Vue = require('vue');
let Promise = require('bluebird');

const debounce = require('microsistec/debounce')

let buildElement = (self) => {
    let callback = null;

    if (self.params.debounce) {
        callback = debounce(function () {
            self.set($(this).val() || 0);
        }, 2000, null, () => {
            if (self.params.onChanging) {
                self.params.onChanging();
            }
        });
    } else {
        callback = function () {
            self.set($(this).val() || 0);
        };
    }

    $(self.el).unbind().TouchSpin({
        min: 0,
        max: Infinity,
        verticalbuttons: true,
        verticalupclass: 'glyphicon glyphicon-plus',
        verticaldownclass: 'glyphicon glyphicon-minus'
    }).on('change', callback);
};

Vue.directive('numeric', {
    twoWay: true,
    priority: 1000,

    params: ['min', 'max', 'accept-negative', 'is-disabled', 'on-changing', 'debounce'],

    paramWatchers: {
        isDisabled(newVal, oldVal) {
            $(this.el).prop('disabled', newVal);
        },
        debounce() {
            buildElement(this);
        }
    },

    bind: function () {
        this.firstUpdate = true;
        buildElement(this);
    },
    update: function (value) {
        $(this.el).val(value);

        // avoid flickering of data
        if (this.firstUpdate) {
            this.firstUpdate = false;
        } else {
            $(this.el).trigger('change')
        }
    },
    unbind: function () {
        //$(this.el).off().select2('destroy')
    }
});



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/numeric.js